import { type AnyAction } from 'redux';
import { type FastFormSubmitAction } from '../fast-form-context';
import { SUBMIT_FAST_FORM } from './fast-form-actions';

export function fastFormSubmit(
  state: FastFormSubmitAction | null = null,
  action: AnyAction,
): FastFormSubmitAction | null {
  switch (action.type) {
    case SUBMIT_FAST_FORM:
      return action.payload;
    default:
      return state;
  }
}
